<div class="dialog-header">
    <h2 mat-dialog-title>Copy Deal</h2>
    <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
  <form [formGroup]="copyForm">
    <div class="d-flex">
      <div>
        <mat-form-field appearance="fill" class="input-date-narrow">
          <mat-label>Closing Date</mat-label>
          <input matInput
            formControlName="closingDate"
            id="closingDate"
            data-test="copy-closing-date-input"
            [matDatepicker]="closingDatePicker">
          <mat-hint>dd/MM/yyyy</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="closingDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #closingDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="fill">
          <mat-label>Deal Name</mat-label>
          <input matInput
            formControlName="projectName"
            data-test="copy-deal-name-input"
            placeholder="Deal Name">
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" data-test="copy-confirm-button" [disabled]="copyForm.invalid" (click)="copyDeal()">Copy Deal</button>
</mat-dialog-actions>
